import palette from '../palette';

export default {
  root: {
    '&$focused': {
      backgroundColor: palette.common.white,
    },
  },
};
